module.exports = __webpack_public_path__ + "static/media/logo-no-text.6a021a56.png";